import { render } from "./BookmarkModal.vue?vue&type=template&id=64eff96e&scoped=true"
import script from "./BookmarkModal.vue?vue&type=script&lang=js"
export * from "./BookmarkModal.vue?vue&type=script&lang=js"

import "./BookmarkModal.vue?vue&type=style&index=0&id=64eff96e&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/environment/links-frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64eff96e"]])

export default __exports__